import axios from "axios";
import { formatDate } from "utils/date";
import { buildQuery } from "utils/queryUtils";

export const findDependentList = (headers, params) => {
    let query = buildQuery(params, []);
    if (params.filters?.idNumber?.value) {
        query += `&idNumber=${params.filters.idNumber.value?.trim()}`;
    }
    if (params.filters.fullName?.value) {
        query += `&fullName=${params.filters.fullName.value?.trim().toLowerCase()}`;
    }
    if (params.filters.birthDate?.value) {
        query += `&birthDay=${formatDate(params.filters.birthDate.value)}`;
    }
    if (params.filters.idNumberDependent.value) {
        query += `&idNumberDependent=${params.filters.idNumberDependent.value.trim()}`;
    }
    return axios.get(`${process.env.REACT_APP_INFO_API_URL}/dependents/list${query}`, {
        headers,
    });
};

export const findDependentHistoryList = (headers, idNumber) => {
    return axios.get(`${process.env.REACT_APP_INFO_API_URL}/dependents/history/${idNumber}`, {
        headers,
    });
};
